import { cn, useIsMobile } from '@heidi/utils';
import { useIsPresent } from 'motion/react';
import { useEffect, useRef } from 'react';
import { DictationBubbleShell } from '../../../shared/components/dictation-bubble-shell';
import { DictationCloseButton } from '../../../shared/components/dictation-close-button';
import { DictationErrorContent } from '../../../shared/components/dictation-error-content';
import { DICTATION_BUBBLE_Z_INDEX_CLASS } from '../../../shared/styles';
import { useDictationClose } from '../../hooks/useDictationClose';
import { useDictationStore } from '../../store/useDictationStore';
import { bubbleExitAnimation, MESSAGE_DISPLAY_DURATION_MS } from '../consts/animation';

export const DictationError = () => {
  const isPresent = useIsPresent();
  const isMobile = useIsMobile();

  // Read from store
  const storeMessageLevel = useDictationStore((s) => s.messageLevel);
  const storeErrorCode = useDictationStore((s) => s.errorCode);
  const persistent = useDictationStore((s) => s.persistent);
  const { handleClose, reset } = useDictationClose();

  // Capture values - only update when component is present (not exiting)
  const capturedValues = useRef({
    messageLevel: storeMessageLevel,
    errorCode: storeErrorCode,
  });

  if (isPresent) {
    capturedValues.current = {
      messageLevel: storeMessageLevel,
      errorCode: storeErrorCode,
    };
  }

  // Use captured values for display (frozen during exit animation)
  const { messageLevel, errorCode } = capturedValues.current;

  useEffect(() => {
    if (persistent) return;

    const timeoutId = setTimeout(() => {
      reset();
    }, MESSAGE_DISPLAY_DURATION_MS);

    return () => clearTimeout(timeoutId);
  }, [errorCode, persistent, reset]);

  return (
    <DictationBubbleShell
      animation={bubbleExitAnimation}
      opaque
      className={cn(
        'fixed inset-x-0 mx-auto flex h-15 w-fit min-w-87.5 items-center justify-center',
        DICTATION_BUBBLE_Z_INDEX_CLASS,
        isMobile ? 'bottom-32' : 'bottom-6'
      )}
    >
      <DictationCloseButton onClose={handleClose} />
      <DictationErrorContent
        errorCode={errorCode}
        messageLevel={messageLevel}
        showHelpLink
      />
    </DictationBubbleShell>
  );
};
